import { useTranslation } from 'react-i18next'
import { ColumnLink } from '~/shared/ui/AsyncGrid'

type ButtonGoWebSiteProps = {
  webSite: string
}
export function ButtonGoWebSite({ webSite }: ButtonGoWebSiteProps) {
  const { t } = useTranslation()

  return (
    <ColumnLink href={webSite} target='_blank'>
      {t('button.go')}
    </ColumnLink>
  )
}
